import styled from 'styled-components';

import { theme } from '../../../global';

export const Container = styled.div<{
  $isActive?: boolean;
  $bgColor?: string;
  $isDisabledPadding?: boolean;
}>`
  width: 100%;
  padding: ${({ $isDisabledPadding }) => ($isDisabledPadding ? '8px 0' : '8px 20px')};
  border-radius: 16px;
  background-color: ${({ $bgColor }) => $bgColor ?? theme.colors.white};
  transition: background-color 0.1s ease-in-out;
`;

export const Title = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.5px;
  color: ${theme.colors.font_dark};
  text-transform: uppercase;
  cursor: pointer;

  svg {
    transform: rotate(${({ $isActive }) => ($isActive ? '180deg' : '0deg')});
    transition: transform 0.1s ease-in-out;
  }
`;

export const Content = styled.div<{ $isActive?: boolean }>`
  padding-top: ${({ $isActive }) => ($isActive ? '16px' : '0')};
  max-height: ${({ $isActive }) => ($isActive ? 'max-content' : '0')};
  //transform: scaleY(${({ $isActive }) => ($isActive ? 1 : 0)});
  transition:
    //transform 0.1s ease-in-out,
    padding-top 0.1s ease-in-out;
  overflow: hidden;
`;
